
export type GetLectureDetail200ResponseResourcesItemType = typeof GetLectureDetail200ResponseResourcesItemType[keyof typeof GetLectureDetail200ResponseResourcesItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLectureDetail200ResponseResourcesItemType = {
  PDF: 'PDF',
  LINK: 'LINK',
  CODE: 'CODE',
  DOWNLOAD: 'DOWNLOAD',
} as const;
